'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import Loading from '@/legacy/components/feature/Loading';
import { defaultLocale } from '@/i18n/routing';

const Home = () => {
	const router = useRouter();

	useEffect(() => {
		// Use browser language or default locale
		const browserLang = navigator.language.toLowerCase();
		const supportedLocales = ['ko', 'en', 'de', 'fr', 'ja', 'vi', 'th', 'es', 'id', 'ms', 'zh-cn', 'zh-tw', 'mn'];
		const locale = supportedLocales.includes(browserLang)
			? browserLang
			: supportedLocales.includes(browserLang.split('-')[0])
				? browserLang.split('-')[0]
				: defaultLocale;
		router.replace(`/${locale}`);
	}, []);

	return <Loading />;
};
export default Home;
